/**
 * Вход в кабинет: раздел по умолчанию зависит от организации. У турагентства главное — поездки,
 * у обычного поставщика их не бывает вовсе, и показывать ему пустой раздел незачем.
 *
 * Сам список уже лежит в кэше запроса `['cabinet','trips']`, поэтому раздел, в который мы
 * уходим, отрисуется без второго обращения к бэку.
 */
import { useQuery } from '@tanstack/react-query'
import { Redirect } from 'expo-router'

import { api } from '../../src/api/client'
import { CabinetShell } from '../../src/features/cabinet/CabinetShell'
import { SkeletonLines } from '../../src/ui'

export default function CabinetIndexScreen() {
  const trips = useQuery({ queryKey: ['cabinet', 'trips'], queryFn: api.cabinetTrips })
  if (trips.isLoading)
    return (
      <CabinetShell section="trips">
        <SkeletonLines lines={3} />
      </CabinetShell>
    )
  // Ошибка выдачи поездок (403 у заблокированного доступа) — тоже в договоры: там тот же
  // QueryState объяснит, что доступа нет, и не оставит партнёра на пустом экране.
  return <Redirect href={trips.data?.length ? '/cabinet/trips' : '/cabinet/contracts'} />
}
